<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box no-display" v-if="ay_std_div_list != null">
      <v-toolbar class="toolbar no-display" flat dense>
        <v-toolbar-title>
          <strong> Get Student Report </strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row justify="center" dense class="no-display">
        <v-col cols="12" sm="2" md="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="sel_ay_data"
            return-object
            :items="ay_std_div_list"
            item-text="ay"
            label="Select Academic Year"
            outlined
            persistent-hint
            hint="Please select academic year"
            @change="getStud()"
          />
        </v-col>
        <v-col cols="12" sm="2" md="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            dense
            required
            outlined
            rounded
            color="#0F2027"
            v-model="sem"
            :items="semester_list"
            item-text="display_name"
            return-object
            label="Semester"
            persistent-hint
            hint="Please select semester"
            @click="
              show = false;
              putnull();
            "
          />
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            v-model="registration_no"
            rounded
            color="#0F2027"
            :items="stud_list"
            label="Select Student"
            item-text="name"
            item-value="registration_number"
            @change="
              addtomarksheet();
              getAnnualMarksheet();
            "
            outlined
            dense
            @click="show = false"
          />
        </v-col>
        <v-col
          cols="12"
          sm="2"
          md="2"
          v-if="sel_ay_data && registration_no && sem"
        >
          <v-btn class="mt-6 button" @click="getreport()"
            >Fetch / Generate 1</v-btn
          >
        </v-col>
        <v-col
          cols="12"
          sm="2"
          md="2"
          v-if="sel_ay_data && registration_no && sem"
        >
          <v-btn class="mt-6 button" @click="getreport2()"
            >Fetch / Generate 2</v-btn
          >
        </v-col>
      </v-row>
    </v-card>
    <!-- <span v-if="show == true && sem.display_name !='Annual'">
            <preprimary-learner-marksheet></preprimary-learner-marksheet> 
        </span>
         <span v-if="show == true && sem.display_name =='Annual' && anuual_report == true">
            <preprimary-annual-learner-marksheet></preprimary-annual-learner-marksheet>
        </span> -->
  </div>
</template>
<script>
import axios from "axios";
import jsPDF from "jspdf";
import PrePrimaryMarksheet from "./PrePrimaryMarksheet";
import PrePrimaryMarksheetAnnual from "./PrePrimaryMarksheetAnnual";
import "jspdf-autotable";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  components: {
    "preprimary-learner-marksheet": PrePrimaryMarksheet,
    "preprimary-annual-learner-marksheet": PrePrimaryMarksheetAnnual,
  },
  data() {
    return {
      default_value: [],
      dialog_marks: false,
      overlay: false,
      selected: [],
      snackbar: false,
      search: "",
      snackbar_msg: "",
      color: "",
      snackbar: false,
      ay_std_div_list: null,
      sel_ay_data: null,
      fetch_loader: false,
      show: false,
      course_list: [],
      stud_list: [],
      awspath: "",
      registration_no: null,
      standard: null,
      div: null,
      ay: null,
      name: null,
      dob: null,
      roll_no: null,
      mobile_no: null,
      address: null,
      mother_name: null,
      photo: null,
      reg_no: null,
      father_full_name: null,
      leraner_marksheet: [],
      sem: null,
      colspan: null,
      overall_grade: null,
      remark: [],
      semester_list: [],
      anuual_report: false,
    };
  },
  methods: {
    getAnnualMarksheet() {
      if (this.sem.display_name == "Annual") {
        const data = {
          lid: this.registration_no,
          ay: this.sel_ay_data.ay_id,
          sem: this.sem.id,
        };
        axios
          .post("/Examination/checkAnnualMarksheet", data)
          .then((res) => {
            if (res.data.msg == "200") {
              if (res.data.flag == "No") {
                this.showSnackbar(
                  "#b71c1c",
                  "Please generate both semester marksheet..."
                );
                this.anuual_report = false;
              }
              if (res.data.flag == "Yes") {
                this.anuual_report = true;
              }
            } else {
              this.showSnackbar("#b71c1c", "Something went wrong...");
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong...");
          })
          .finally(() => {
            this.comp_load = false;
          });
      }
    },
    getreport() {
      // this.$store.commit("setay", this.sel_ay_data.ay_id);
      // this.$store.commit("setreg_no", this.registration_no);
      //  this.$store.commit("setsem", this.sem.id);
      // this.show = true;
      if (this.sem.display_name == "Annual" && this.anuual_report == true) {
        // this.$store.commit("setay", this.sel_ay_data.ay_id);
        // this.$store.commit("setsem", this.sem.id);
        // this.$store.commit("setreg_no", this.registration_no);
        //  localStorage.setItem("setay", this.sel_ay_data.ay_id);
        localStorage.setItem("setay", this.sel_ay_data.ay_id);
        localStorage.setItem("setsem", this.sem.id);
        localStorage.setItem("setreg_no", this.registration_no);
        this.show = true;
        let routeData = this.$router.resolve({
          name: "sbpps-preprimary-ms-parent-annual",
        });
        window.open(routeData.href, "_blank");
      } else {
        // this.$store.commit("setay", this.sel_ay_data.ay_id);
        // this.$store.commit("setsem", this.sem.id);
        // this.$store.commit("setreg_no", this.registration_no);
        localStorage.setItem("setay", this.sel_ay_data.ay_id);
        localStorage.setItem("setsem", this.sem.id);
        localStorage.setItem("setreg_no", this.registration_no);
        this.show = true;
        let routeData = this.$router.resolve({ name: "sbpps-preprimary-ms" });
        window.open(routeData.href, "_blank");
      }
    },
    getreport2() {
      // this.$store.commit("setay", this.sel_ay_data.ay_id);
      // this.$store.commit("setreg_no", this.registration_no);
      //  this.$store.commit("setsem", this.sem.id);
      // this.show = true;
      if (this.sem.display_name == "Annual" && this.anuual_report == true) {
        // this.$store.commit("setay", this.sel_ay_data.ay_id);
        // this.$store.commit("setsem", this.sem.id);
        // this.$store.commit("setreg_no", this.registration_no);
        //  localStorage.setItem("setay", this.sel_ay_data.ay_id);
        localStorage.setItem("setay", this.sel_ay_data.ay_id);
        localStorage.setItem("setsem", this.sem.id);
        localStorage.setItem("setreg_no", this.registration_no);
        this.show = true;
        let routeData = this.$router.resolve({
          name: "sbpps-preprimary-ms-parent-annual-2",
        });
        window.open(routeData.href, "_blank");
      } else {
        // this.$store.commit("setay", this.sel_ay_data.ay_id);
        // this.$store.commit("setsem", this.sem.id);
        // this.$store.commit("setreg_no", this.registration_no);
        localStorage.setItem("setay", this.sel_ay_data.ay_id);
        localStorage.setItem("setsem", this.sem.id);
        localStorage.setItem("setreg_no", this.registration_no);
        this.show = true;
        let routeData = this.$router.resolve({ name: "sbpps-preprimary-ms" });
        window.open(routeData.href, "_blank");
      }
    },
    putnull3() {
      this.show = false;
    },
    putnull() {
      this.registration_no = null;
    },
    addtomarksheet() {
      if (this.sem.display_name != "Annual") {
        const data = {
          lid: this.registration_no,
          ay: this.sel_ay_data.ay_id,
          sem: this.sem.id,
          org: this.org,
        };
        axios
          .post("/Examination/getpreprimaryStudentReport", data)
          .then((res) => {})
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            this.fetch_loader = false;
          })
          .finally(() => {});
      }
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    getStud() {
      const data = {
        ay: this.sel_ay_data.ay_id,
      };
      axios
        .post("/Examination/getAllPreprimaryStudents", data)
        .then((res) => {
          if (res.data.msg == "200") {
            this.stud_list = res.data.stud_list;
          } else {
            alert("Somthing went wrong!!!");
          }
        })
        .catch((error) => {
          alert("Somthing went wrong!!!");
        })
        .finally(() => {
          this.comp_load = false;
        });
    },
    onload() {
      axios
        .post("/commonAPI/get_ay_std_div")
        .then((res) => {
          this.ay_std_div_list = res.data.data;
          this.semester_list = res.data.sem_list;
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
  },
  mounted() {
    this.onload();
    this.awspath = localStorage.getItem("awspath");
  },
};
</script>
<style scoped>
@media print {
  .card {
    border: none !important;
    font-size: large !important;
  }
  .pagebreak {
    page-break-before: always;
  }
  header,
  footer,
  nav,
  date {
    display: none !important;
  }
  table,
  td,
  tr {
    break-inside: avoid-page;
  }
  /* img {
            width: 100% !important;
        } */
  body,
  tr,
  th,
  td {
    font-size: large !important;
  }
  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }
  v-card {
    border: none !important;
  }
  @page {
    size: A4;
    margin-top: none;
    padding-top: none;
    size: 15.5in 15.5in;
  }
  thead {
    font-weight: bold !important;
  }
  /* table,
        tr,
        th {
            text-align: center !important;
            margin-top: none;
            padding: none !important;
            border-bottom: 1px solid black;
            border: 1px solid black;
        } */
}
</style>
